export default "__VITE_ASSET__2dd2572b__"